export type DefaultNowType = () => string
export const defaultNow: DefaultNowType = () => new Date().toISOString()
